// extracted by mini-css-extract-plugin
export default {"form":"PreferenceTypeThree_form__7FRCY"};